'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _iBem = require('../../../i-bem/i-bem.react');

var _bIServices = (require('./../../../i-services/i-services.react.js').default || require('./../../../i-services/i-services.react.js')).applyDecls();

var _bIServices2 = _interopRequireDefault(_bIServices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.declMod)({ action: 'mail' }, {
    block: 'user2',
    elem: 'menu-item',
    content: function content(_ref) {
        var contentRegion = _ref.contentRegion;

        return _bIServices2.default.serviceName('mail', contentRegion);
    },
    attrs: function attrs(_ref2) {
        var contentRegion = _ref2.contentRegion;

        return _extends({}, this.__base.apply(this, arguments), {
            href: _bIServices2.default.serviceUrl('mail', contentRegion)
        });
    }
});